export { default as AboutWasticContainer } from './AboutWasticContainer/AboutWasticContainer';
export { default as ContactUsContainer } from './ContactUsContainer/ContactUsContainer';
export { default as FAQContainer } from './FAQContainer/FAQContainer';
export { default as HomeContainer } from './HomeContainer/HomeContainer';
export { default as WasticFolksContainer } from './WasticFolksContainer/WasticFolksContainer';